// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Hr3F","footer":"styles_footer__1kO5R"};